module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/phone_coins-906c3eec3bc7473ef179c298c3bff22d.png";